import { render, staticRenderFns } from "./SBadge.vue?vue&type=template&id=7f21b30c&scoped=true&"
import script from "./SBadge.vue?vue&type=script&lang=js&"
export * from "./SBadge.vue?vue&type=script&lang=js&"
import style0 from "./SBadge.vue?vue&type=style&index=0&id=7f21b30c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21b30c",
  null
  
)

export default component.exports